import { z } from 'zod';
import { encryptedTokenSetGuard } from '../secrets.js';
import { extendedSocialUserInfoGuard } from '../sso-connector.js';
import { VerificationType } from './verification-type.js';
export const enterpriseSsoVerificationRecordDataGuard = z.object({
    id: z.string(),
    connectorId: z.string(),
    type: z.literal(VerificationType.EnterpriseSso),
    enterpriseSsoUserInfo: extendedSocialUserInfoGuard.optional(),
    encryptedTokenSet: encryptedTokenSetGuard.optional(),
    issuer: z.string().optional(),
});
export const sanitizedEnterpriseSsoVerificationRecordDataGuard = enterpriseSsoVerificationRecordDataGuard.omit({
    encryptedTokenSet: true,
});
